var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.297,
    height: 122.519,
    viewBox: "0 0 183.297 122.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-2.5 -18.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M159.749,18.2H28.547A25.939,25.939,0,0,0,2.5,44.247v70.425a25.939,25.939,0,0,0,26.047,26.047h131.2A25.939,25.939,0,0,0,185.8,114.672V44.247A26.062,26.062,0,0,0,159.749,18.2ZM119.617,83.994l-38.01,23.732a5.2,5.2,0,0,1-7.911-4.438V55.824a5.2,5.2,0,0,1,7.911-4.438l38.01,23.732A5.41,5.41,0,0,1,119.617,83.994Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c3873374036295b101ede100ffcf45f7.svg";
export { ForwardRef as ReactComponent };